import "jquery";
import { registerElement as animationRegisterElement } from "hypo_elements/Typescripts/Animation/Animation";

$(() => {

	function moveCta(
		topzins,
		target,
	) {
		let cta = $(topzins).find(".topzins-plugin_cta");
		let daten = $(topzins).find(".topzins-plugin_daten");
		let zinsContainer = $(topzins).find(".topzins-plugin_zinsContainer");
		if (target == "mobile") {
			$(daten).before($(cta));
		} else {
			$(cta).appendTo($(zinsContainer));
		}
	}

	$(".topzins-plugin").each(function () {
		let topZinsWidth = $(this).innerWidth() || 0;
		if (topZinsWidth < 660) {
			$(this).addClass("mobile");
			moveCta(this, "mobile");
		}
		animationRegisterElement($(this).find(".topzins-plugin_zinsNumber").data("animation-kind", "number"));
	});

	$(window).on("resize", function () {
		$(".topzins-plugin").each(function () {
			let topZinsWidth = $(this).innerWidth() || 0;
			if (topZinsWidth < 660) {
				if (!$(this).hasClass("mobile")) {
					$(this).addClass("mobile");
					moveCta(this, "mobile");
				}
			} else {
				if ($(this).hasClass("mobile")) {
					$(this).removeClass("mobile");
					moveCta(this, "desktop");
				}
			}
		});
	});

});
